module.exports = __webpack_public_path__ + "e4f0091d5e58f68dd4fea0928fa5f97c.png";